import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {IChange, IRelease} from 'app/types/Shared';
import {RootState} from '..';

export const changeApi = createApi({
  reducerPath: 'changeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASEURL || 'http://localhost:3500',
    prepareHeaders: (headers, {getState}) => {
      const authToken = (getState() as RootState).auth.token;
      // Use idToken for all API calls (OIDC standard for own API)
      if (authToken) headers.set('Authorization', `Bearer ${authToken.idToken}`);

      return headers;
    },
  }),
  tagTypes: ['changeApi'],
  endpoints(builder) {
    return {
      getAllReleases: builder.query<Array<IRelease>, void>({
        query: () => {
          return {
            url: `/releases`,
            method: 'GET',
          };
        },
      }),
      getChangesByRelease: builder.query<Array<IChange>, Array<string>>({
        query: (releases) => {
          console.log(releases);
          const encodedReleases = releases.join('|');
          return {
            url: `/changes/${encodedReleases}`,
            method: 'GET',
          };
        },
      }),
      getNewProcesses: builder.query<Array<IChange>, string>({
        query: (release) => {
          return {
            url: `/changes/newProcesses/${release}`,
            method: 'GET',
          };
        },
      }),
    };
  },
});

export const {useGetAllReleasesQuery, useGetChangesByReleaseQuery, useGetNewProcessesQuery} = changeApi;
